/**
 * Product PropTypes
 *
 * PropType definitions for product objects
 * Includes basic product information, pricing, images, and reviews
 *
 * @module propTypes/common/product
 */

import PropTypes from "prop-types";

/**
 * Product PropType
 * Base product shape used throughout the application
 *
 * @property {number} id - Numeric product ID
 * @property {string} documentId - Document identifier from Strapi
 * @property {string} name - Product name (required)
 * @property {string} slug - URL slug (required)
 * @property {boolean} sunglasses - Whether product is sunglasses
 * @property {string} model - Product model
 * @property {string} color - Product color
 * @property {string} size - Product size
 * @property {number} price - Base price (required)
 * @property {string} description - Product description
 * @property {Array<string>} images - Array of image URLs
 * @property {Object} reviews - Review statistics
 * @property {number} reviews.total_reviews - Total review count
 * @property {number} reviews.total_rating - Total rating sum
 * @property {number} reviews.rating - Average rating
 */
const productPropType = PropTypes.shape({
  id: PropTypes.number,
  documentId: PropTypes.string,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  sunglasses: PropTypes.bool,
  model: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  price: PropTypes.number.isRequired,
  description: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.string),
  reviews: PropTypes.shape({
    total_reviews: PropTypes.number,
    total_rating: PropTypes.number,
    rating: PropTypes.number,
  }),
});

export default productPropType;
